import { createStore } from "vuex";
import { mainModule } from "./mainModule";
import { pageModule } from "./pageModule";

export default createStore({
  modules: {
    main: mainModule,
    page: pageModule,
  }
})